// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file reorder.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file reorder.proto.
 */
export const file_reorder: GenFile = /*@__PURE__*/
  fileDesc("Cg1yZW9yZGVyLnByb3RvEgtncnBjLmFwaS52MSIqCg1SZW9yZGVyRW50aXR5EgoKAmlkGAEgASgDEg0KBW9yZGVyGAIgASgFIj4KDlJlb3JkZXJSZXF1ZXN0EiwKCGVudGl0aWVzGAEgAygLMhouZ3JwYy5hcGkudjEuUmVvcmRlckVudGl0eUIGWgQuO3BiYgZwcm90bzM");

/**
 * @generated from message grpc.api.v1.ReorderEntity
 */
export type ReorderEntity = Message<"grpc.api.v1.ReorderEntity"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int32 order = 2;
   */
  order: number;
};

/**
 * Describes the message grpc.api.v1.ReorderEntity.
 * Use `create(ReorderEntitySchema)` to create a new message.
 */
export const ReorderEntitySchema: GenMessage<ReorderEntity> = /*@__PURE__*/
  messageDesc(file_reorder, 0);

/**
 * @generated from message grpc.api.v1.ReorderRequest
 */
export type ReorderRequest = Message<"grpc.api.v1.ReorderRequest"> & {
  /**
   * @generated from field: repeated grpc.api.v1.ReorderEntity entities = 1;
   */
  entities: ReorderEntity[];
};

/**
 * Describes the message grpc.api.v1.ReorderRequest.
 * Use `create(ReorderRequestSchema)` to create a new message.
 */
export const ReorderRequestSchema: GenMessage<ReorderRequest> = /*@__PURE__*/
  messageDesc(file_reorder, 1);

